import { useSelector } from 'react-redux';
import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const DynamicFormDefaultWidget = (props) => {
  const global = useSelector((state) => state.global);
  return (
    <DefaultWidgetTemplate
      module={props.module}
      oldRoute={`${global?.urlData?.rootProject}df/home/${props.module[props.module.name].slug}/`}
    />
  );
};

export default DynamicFormDefaultWidget;
